<template>
  <div class="rangeIvvi">
    <div class="header">
        <img src="../images/banner.png" alt="" width="100%" style="margin-bottom:15px;">
    </div>
    <p class="doc_title">免费WiFi用户安全理赔计划</p>
    <p class="doc_text">免费WiFi用户安全理赔计划是指免费WiFi用户在使用免费WiFi连接网络的过程中，因在通过免费WiFi连接的热点网络环境下发生了服务协议中列明的WiFi热点恶意行为，导致用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失，用户可按照本保险计划的有关规则申请索赔。</p>

    <p class="doc_title">提供保障</p>
    <p class="doc_text">每人单次可理赔金额10000元<br>每人最高可理赔金额高达100000元</p>

    <p class="doc_title">重要提示</p>
    <p class="doc_text">1.用户必须是免费WiFi的手机注册用户，且其安装并使用的免费WiFi手机客户端中必须已发布施行了本保险计划（即用户必须安装安卓版免费WiFi 4.1.8版本及此后发布的更新版本）。</p>
    <p class="doc_text">2.向免费WiFi提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。</p>
  </div>
</template>

<script>
export default {
  name: 'rangeIvvi',
  mounted:function(){
    // Utils.Tracker.send({
    //     data: {
    //         f: 'wifiins',
    //         b: 'ins_detail'
    //     }
    // });
    this.$trace.enterTraceDone({ page: 6,  type: 'rangeIvvi'})
  }
}
</script>

<style scoped>
.doc_title{margin-top: 0;margin-bottom: 10px;padding-top: 0;}
</style>



// WEBPACK FOOTER //
// rangeIvvi.vue?6feb3366